module.exports = __webpack_public_path__ + "media/images/caret-down-d8982f619840d87eee37b6ab645518bf.svg";